module.exports = __webpack_public_path__ + "static/img/6178_phase_function_Paper_PointsHejduk_Prediction.dbbf7e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6178_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nYuj
// module chunks = 0